import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FadingCircle } from 'better-react-spinkit';
import './Spinner.scss';

class Spinner extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
  };

  static defaultProps = {
    className: '',
    size: 50,
  };

  render() {
    return (
      <div className={classnames('common-spinner', this.props.className)}>
        <FadingCircle size={this.props.size} color={this.props.color} />
      </div>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/spinner/Spinner.js